/**
 * Dynamic Best Seller Badge Handler for Make My Bundle / GBB Grid
 * Detects products with the 'best-seller' / 'best-seller-teg' tag dynamically from Shopify
 * and renders a clean 'BESTSELLER' badge ONLY on matching products.
 */
(function () {
  "use strict";

  var bestSellerIds = new Set();
  if (
    window.__RAMSONS_BEST_SELLERS__ &&
    Array.isArray(window.__RAMSONS_BEST_SELLERS__)
  ) {
    window.__RAMSONS_BEST_SELLERS__.forEach(function (id) {
      if (id) bestSellerIds.add(String(id).trim());
    });
  }

  var isFetching = false;
  var productsLoaded = false;
  var applyTimeout = null;

  function isBestSellerTag(tag) {
    if (!tag) return false;
    var t = String(tag).trim().toLowerCase();
    return (
      t === "best-seller" ||
      t === "bestseller" ||
      t === "best-seller-teg" ||
      t === "best seller"
    );
  }

  function fetchProductsData(page) {
    if (productsLoaded) return;
    page = page || 1;
    isFetching = true;

    fetch("/products.json?limit=250&page=" + page)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        if (data && data.products && data.products.length > 0) {
          data.products.forEach(function (prod) {
            var tagList = [];
            if (Array.isArray(prod.tags)) {
              tagList = prod.tags;
            } else if (typeof prod.tags === "string") {
              tagList = prod.tags.split(",");
            }

            var hasBestSellerTag = tagList.some(isBestSellerTag);
            if (hasBestSellerTag) {
              bestSellerIds.add(String(prod.id));
            }
          });

          // Re-evaluate badges on current items
          scheduleBadgeUpdate();

          if (data.products.length === 250) {
            fetchProductsData(page + 1);
          } else {
            productsLoaded = true;
            isFetching = false;
            scheduleBadgeUpdate();
          }
        } else {
          productsLoaded = true;
          isFetching = false;
          scheduleBadgeUpdate();
        }
      })
      .catch(function () {
        isFetching = false;
      });
  }

  function applyBestSellerBadges() {
    var items = document.querySelectorAll(".gbbProductItem");
    if (!items || items.length === 0) return;

    items.forEach(function (item) {
      var prodId =
        item.getAttribute("productid") ||
        item.getAttribute("data-product-id") ||
        item.getAttribute("data-prod");
      if (!prodId) return;

      var imgContainer = item.querySelector(".gbbProductImageContainer");
      if (!imgContainer) return;

      var isBestseller = bestSellerIds.has(String(prodId).trim());
      var existingBadge = imgContainer.querySelector(".gbb-bestseller-badge");

      if (isBestseller) {
        if (!existingBadge) {
          var badge = document.createElement("span");
          badge.className = "gbb-bestseller-badge";
          badge.textContent = "BESTSELLER";
          imgContainer.appendChild(badge);
        }
      } else {
        if (existingBadge) {
          existingBadge.remove();
        }
      }
    });
  }

  function scheduleBadgeUpdate() {
    if (applyTimeout) clearTimeout(applyTimeout);
    applyTimeout = setTimeout(applyBestSellerBadges, 40);
  }

  function getAppBundleTitle() {
    var bundleId = "";
    var pathMatch = window.location.pathname.match(
      /\/apps\/gbb\/easybundle\/([^\/\?#]+)/i,
    );
    if (pathMatch && pathMatch[1]) {
      bundleId = String(pathMatch[1]).trim();
    } else if (window.gbb && window.gbb.state && window.gbb.state.bundleId) {
      bundleId = String(window.gbb.state.bundleId).trim();
    }

    // 1. Try reading from EasyBundle bootstrap data (<script data-gbb-bootstrap="bundles">)
    var bootstrapScript = document.querySelector(
      'script[data-gbb-bootstrap="bundles"]',
    );
    if (bootstrapScript && bootstrapScript.textContent) {
      try {
        var parsedData = JSON.parse(bootstrapScript.textContent);
        var bundleLinkList =
          parsedData && parsedData.extData && parsedData.extData.bundleLinkData;
        if (Array.isArray(bundleLinkList)) {
          for (var i = 0; i < bundleLinkList.length; i++) {
            var b = bundleLinkList[i];
            if (b && String(b.bundleId).trim() === bundleId) {
              if (b.bundleName && b.bundleName.trim()) {
                return b.bundleName.trim();
              }
              if (
                b.productsForBundleLink &&
                b.productsForBundleLink[0] &&
                b.productsForBundleLink[0].title
              ) {
                return b.productsForBundleLink[0].title.trim();
              }
            }
          }
        }
      } catch (e) {}
    }

    // 2. Try window.gbb state or settings
    if (window.gbb) {
      if (
        window.gbb.state &&
        window.gbb.state.bundleName &&
        window.gbb.state.bundleName.trim()
      ) {
        return window.gbb.state.bundleName.trim();
      }
      if (
        window.gbb.settings &&
        window.gbb.settings.stepsConfigurationData &&
        window.gbb.settings.stepsConfigurationData.bundleName &&
        window.gbb.settings.stepsConfigurationData.bundleName.trim()
      ) {
        return window.gbb.settings.stepsConfigurationData.bundleName.trim();
      }
    }

    // 3. Fallback map for known bundle IDs
    var knownBundles = {
      7: "Perfume + 2 Attar @ ₹599",
      8: "Perfume + 2 Deo/Attar @ ₹899",
      9: "Buy Any 2 Perfumes @ ₹1399",
    };
    if (bundleId && knownBundles[bundleId]) {
      return knownBundles[bundleId];
    }

    return null;
  }

  function updateBundleBreadcrumbs() {
    var isAppBundlePage =
      (document.body && document.body.id === "mmb-app") ||
      window.location.pathname.indexOf("/apps/gbb/") !== -1 ||
      window.location.pathname.indexOf("/easybundle/") !== -1;

    if (isAppBundlePage) {
      var bundleTitle = getAppBundleTitle();

      // 1. Update breadcrumb list items (Home > Festive Offers > Bundle Name)
      var breadcrumbList = document.querySelector(
        ".breadcrumb-area .breadcrumb-list",
      );
      if (breadcrumbList) {
        // A. Ensure collection link points to Festive Offers
        var links = breadcrumbList.querySelectorAll("a");
        links.forEach(function (link) {
          var href = link.getAttribute("href") || "";
          if (href.indexOf("/collections/make-my-bundle") !== -1) {
            link.href = "/collections/festive-offers";
            link.setAttribute("title", "Festive Offers");
            link.textContent = "Festive Offers";
          }
        });

        // B. Ensure Festive Offers collection item exists after Home
        var hasFestiveLink = false;
        links = breadcrumbList.querySelectorAll("a");
        links.forEach(function (link) {
          var href = link.getAttribute("href") || "";
          if (href.indexOf("/collections/festive-offers") !== -1) {
            hasFestiveLink = true;
          }
        });

        if (!hasFestiveLink) {
          var homeLi = breadcrumbList.querySelector(
            "li.breadcrumb-item:first-child",
          );
          var festiveLi = document.createElement("li");
          festiveLi.className = "breadcrumb-item";
          festiveLi.innerHTML =
            '<a href="/collections/festive-offers" title="Festive Offers">Festive Offers</a>';
          if (homeLi && homeLi.nextSibling) {
            breadcrumbList.insertBefore(festiveLi, homeLi.nextSibling);
          } else {
            breadcrumbList.appendChild(festiveLi);
          }
        }

        // C. Ensure current bundle title item exists as the active (last) breadcrumb item
        if (bundleTitle) {
          var bundleLi = breadcrumbList.querySelector(
            "li.breadcrumb-bundle-item",
          );
          if (!bundleLi) {
            bundleLi = document.createElement("li");
            bundleLi.className = "breadcrumb-item breadcrumb-bundle-item";
            breadcrumbList.appendChild(bundleLi);
          }
          bundleLi.style.display = "";
          bundleLi.innerHTML =
            '<span class="breadcrumb-bundle-text">' + bundleTitle + "</span>";
        }
      }

      // 2. Update breadcrumb main-title to bundle title or name
      var titleH1 = document.querySelector(
        ".breadcrumb-area .breadcrumb-title h1",
      );
      if (titleH1 && bundleTitle) {
        titleH1.textContent = bundleTitle;
        if (!document.title || document.title.trim() === "Ramsons Perfumes") {
          document.title = bundleTitle + " – Ramsons Perfumes";
        }
      }
    } else if (document.body && document.body.id === "make-my-bundle") {
      var bundleTitleH1 = document.querySelector(
        "body#make-my-bundle .breadcrumb-area .breadcrumb-title h1",
      );
      if (
        bundleTitleH1 &&
        bundleTitleH1.textContent.trim().toLowerCase() !== "make my bundle"
      ) {
        bundleTitleH1.textContent = "Make My Bundle";
      }
      var lastBreadcrumbSpan = document.querySelector(
        "body#make-my-bundle .breadcrumb-area .breadcrumb-list li.breadcrumb-item:last-child span",
      );
      if (
        lastBreadcrumbSpan &&
        lastBreadcrumbSpan.textContent.trim().toLowerCase() !== "make my bundle"
      ) {
        lastBreadcrumbSpan.textContent = "Make My Bundle";
      }
    }
  }

  // Initialize
  function init() {
    updateBundleBreadcrumbs();
    document.addEventListener("gbb-page-load", updateBundleBreadcrumbs);
    fetchProductsData(1);
    scheduleBadgeUpdate();

    // Observe DOM for dynamic additions/updates in grid
    var targetNode = document.body || document.documentElement;
    var observer = new MutationObserver(function (mutations) {
      var hasProductChanges = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length > 0) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType === 1) {
              if (
                node.classList &&
                (node.classList.contains("gbbProductItem") ||
                  node.classList.contains("gbbProductsItemsContainer") ||
                  node.querySelector(".gbbProductItem"))
              ) {
                hasProductChanges = true;
                break;
              }
            }
          }
        }
        if (hasProductChanges) break;
      }

      if (hasProductChanges) {
        updateBundleBreadcrumbs();
        scheduleBadgeUpdate();
        if (!productsLoaded && !isFetching) {
          fetchProductsData(1);
        }
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
